<div class="modal-reservation-visite">
  <ng-template #content let-modal>
    <div class="modal-header-bg">
      <div class="modal-header container">
        <h4 class="modal-title" aria-label="The Door Man">
          <img width="109" height="51" src="../../../../assets/logo/logo-white.svg" alt="The Door Man">
          <span class="visually-hidden">The Door Man</span>
        </h4>
        <button type="button" class="btn-close btn-close-white me-1" aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
        <span>Quitter</span>
      </div>
    </div>
    <div class="modal-body p-0">
      <div id="stepper1" class="bs-stepper h-100">
        <div class="bs-stepper-header p-0">
          <div class="line"></div>
          <div class="step" data-target="#test-l-1">
            <button class="step-trigger">
            </button>
          </div>
          <div class="line" [ngClass]="{'bs-stepper-line-active': stepIndex < 1}"></div>
          <div class="step" data-target="#test-l-2">
            <button class="step-trigger">
            </button>
          </div>
          <div class="line" [ngClass]="{'bs-stepper-line-active': stepIndex < 2}"></div>
          <div class="step" data-target="#test-l-3">
            <button class="step-trigger">
            </button>
          </div>
          <div class="line" [ngClass]="{'bs-stepper-line-active':stepIndex < 3}"></div>
          <div class="step" data-target="#test-l-4">
            <button class="step-trigger">
            </button>
          </div>
          <div class="line" [ngClass]="{'bs-stepper-line-active':stepIndex < 4}"></div>
          <div class="step" data-target="#test-l-5">
            <button class="step-trigger">
            </button>
          </div>
        </div>
        <div class="bs-stepper-content p-0  h-100">
          <form (ngSubmit)="onSubmit()" class="h-100" [formGroup]="searchForm">
            <div id="test-l-1" class="content h-100">
              <div class="form-group row h-100">
                <div class="col-md-6 col-sm-12 p-5">
                  <span class="text-black-50">Estimation sur rendez-vous</span>
                  <h5 for="adresse" class="form-label fw-bolder">Où se situe votre bien à vendre ?</h5>
                  <div class="container-search-input w-100">
                    <span class="close-search-result" *ngIf="searchedAddresses.length > 0"
                      (click)="cancelSearchingAddress()">×</span>
                    <input #locality type="search" class="form-control mt-4 mb-2" id="locality"
                      aria-label="Adresse du bien"
                      placeholder="Ex : 1 rue de la paix, 75000 Paris" autocomplete="off" formControlName="locality"
                      aria-describedby="localitiesHelp" [ngClass]="{ 'is-invalid': submitted && f.locality.errors }" />
                    <div *ngIf="submitted && f.locality.errors" class="invalid-feedback">
                      <div *ngIf="f.locality.errors.required">Champ obligatoire</div>
                    </div>
                  </div>
                  <div *ngIf="searchedAddresses.length > 0" class="result-localities-container">
                    <ul class="list-group list-group-result">
                      <li *ngFor="let locality of searchedAddresses" class="list-group-item elem-result-item"
                        (click)="chooseLocality(locality)">
                        {{locality.ville}}
                      </li>
                    </ul>
                  </div>
                  <button (click)="next()" class="btn btn-gold">Suivant</button>
                </div>
                <div class="col-md-6 col-sm-12 bgStepper h-100 text-white">
                  <div class="row-cols-md-2 row-cols-sm-1">
                    <div class="mt-2 mt-md-5 py-3 py-md-4 px-3 px-md-2">
                      <h4 class="fw-bold">Votre demande d'estimation</h4>
                      <h5 class="my-2">Gratuite et sans engagement !</h5>
                      <span>Vous avez un bien à vendre et vous souhaitez connaître son prix de vente ?
                        <span class="fw-bolder">
                          Répondez à quelques
                          questions et contactez notre équipe
                        </span> pour obtenir votre estimation sur-mesure.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="test-l-2" class="content h-100">
              <div class="form-group h-100">
                <div class="form-group row h-100">
                  <div class="col-md-6 col-sm-12 p-5">
                    <div class="mb-3" role="button" (click)="previous()">
                      <span class="text-black fw-bolder"><i style="color: #00579C;"
                          class="bi bi-arrow-left me-1  h4"></i>
                        Étape précédente</span>
                    </div>
                    <span class="text-black-50">Estimation sur rendez-vous</span>
                    <h5 for="adresse" class="form-label fw-bolder">Votre bien est...</h5>
                    <div class="tabs row">
                      <div *ngFor="let item of subjectForm" (mouseover)="stepFormulaireHover= item.text"
                        (mouseout)="stepFormulaireHover= ''" (click)="setSubject(item)" class="tabs-item"
                        [ngClass]="{active: item.id === typeBienChoosed?.id}">
                        <div class="m-3">
                          <img [src]="'../../../../assets/resources/web/images/design/'+item.id+'-gris.png'">
                        </div>
                        <span>{{item.text}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12 bgStepper h-100 text-white">
                    <div class="row-cols-md-2 row-cols-sm-1">
                      <div class="mt-2 mt-md-5 py-3 py-md-4 px-3 px-md-2">
                        <h4 class="fw-bold">Votre demande d'estimation</h4>
                        <h5 class="my-2">Gratuite et sans engagement !</h5>
                      </div>
                    </div>
                    <div class="row-cols-md-2 row-cols-sm-1 ">
                      <div class="my-2 card p-3 m-3 m-md-0">
                        <h5 class="text-black-50 fw-semibold">VOTRE BIEN</h5>
                        <span class="text-black"><i style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                          {{choosedLocality?.ville}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="test-l-3" class="content h-100">
              <div class="form-group row h-100">
                <div class="col-md-6 col-sm-12 p-5">
                  <div class="mb-3" role="button" (click)="previous()">
                    <span class="text-black fw-bolder"><i style="color: #00579C;" class="bi bi-arrow-left me-1  h4"></i>
                      Étape précédente</span>
                  </div>
                  <span class="text-black-50">Estimation sur rendez-vous</span>
                  <h5 for="adresse" class="form-label fw-bolder mb-1 mb-md-3">Détail de votre bien</h5>
                  <div class="form-group mt-3" *ngIf="typeBienChoosed?.id != 'terrain'">
                    <span class="header-text fw-bolder">Quel est le nombre de pièce(s) ?</span>
                    <div class="mt-1 row row-cols-1 d-flex justify-content-between">
                      <div>
                        <checkbox-group formControlName="nb_piece" *ngIf="filtersNbPiece.length > 0">
                          <ng-container *ngFor="let piece of filtersNbPiece">
                            <checkbox-elem value="{{piece.id}}" [element]="piece"
                              [label]="piece.label == 1 ? 'Studio': piece.label" [context]="'piece'"></checkbox-elem>
                          </ng-container>
                        </checkbox-group>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mt-3" *ngIf="typeBienChoosed?.id != 'terrain'">
                    <span class="header-text fw-bolder">Quel est le nombre de chambre(s) ?</span>
                    <div class="mt-1 row row-cols-1 d-flex justify-content-between">
                      <div>
                        <checkbox-group formControlName="nb_room" *ngIf="filtersNbRoom.length > 0">
                          <ng-container *ngFor="let room of filtersNbRoom">
                            <checkbox-elem value="{{room.id}}" [element]="room" [label]="room.label"
                              [context]="'room'"></checkbox-elem>
                          </ng-container>
                        </checkbox-group>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mt-3">
                    <span class="header-text fw-bolder">Quelle est sa surface ?</span>
                    <div class="mt-1 w-50">
                      <input id="surface-estimation" aria-label="Surface du bien" placeholder="Ex : 100 m2" type="number" class="form-control" formControlName="surface"
                        [ngClass]="{ 'is-invalid': submitted && f.surface.errors }" />
                      <div *ngIf="submitted && f.surface.errors" class="invalid-feedback">
                        <div *ngIf="f.surface.errors.required">Champ obligatoire</div>
                      </div>
                    </div>
                  </div>
                  <button (click)="next()" class="btn my-2 btn-gold">Suivant</button>

                </div>
                <div class="col-md-6 col-sm-12 bgStepper h-100 ">
                  <div class="row-cols-md-2 row-cols-sm-1">
                    <div class="mt-2 mt-md-5 py-3 py-md-4 px-3 px-md-2 text-white">
                      <h4 class="fw-bold">Votre demande d'estimation</h4>
                      <h5 class="my-2">Gratuite et sans engagement !</h5>
                    </div>
                  </div>
                  <div class="row-cols-md-2 row-cols-sm-1 ">
                    <div class="my-2 card p-3 m-3 m-md-0">
                      <h5 class="text-black-50 fw-semibold">VOTRE BIEN</h5>
                      <span class="text-black"><i style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                        {{choosedLocality?.ville}}</span>
                      <span class="text-black"><i style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                        {{typeBienChoosed?.text}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="test-l-4" class="content h-100">
              <div class="form-group h-100">
                <div class="form-group row h-100">
                  <div class="col-md-6 col-sm-12 p-5">
                    <div class="mb-3" role="button" (click)="previous()">
                      <span class="text-black fw-bolder"><i style="color: #00579C;"
                          class="bi bi-arrow-left me-1  h4"></i>
                        Étape précédente</span>
                    </div>
                    <span class="text-black-50">Estimation sur rendez-vous</span>
                    <h5 class="fw-bold  fw-bolder">Vos coordonnées</h5>
                    <span class="text-black-50">Afin de donner suite à votre demande, notre équipe vous recontactera par
                      téléphone.</span>
                    <h5 class="fw-bold my-4">Quand souhaitez-vous être rappelé ?</h5>
                    <div class="my-3">
                      <div class="col-sm-12" [ngClass]="{ 'is-invalid': submitted && f.disponibility.errors }">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="disponibility" id="inlineRadio1"
                                 formControlName="disponibility" value="1">
                          <label class="form-check-label" for="inlineRadio1">Le matin</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="disponibility" id="inlineRadio2"
                                 formControlName="disponibility" value="2">
                          <label class="form-check-label" for="inlineRadio2">L’après-midi</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="disponibility" id="inlineRadio3"
                                 formControlName="disponibility" value="3">
                          <label class="form-check-label" for="inlineRadio3">Peu importe</label>
                        </div>
                      </div>
                      <div *ngIf="submitted && f.disponibility.errors" class="invalid-feedback">
                        <div *ngIf="f.disponibility.errors.required">Champ obligatoire</div>
                      </div>
                    </div>
                    <div class="row my-3">
                      <div class="col-sm-6 mb-1">
                        <label for="nom" class="form-label">Nom</label>
                        <input placeholder="Ex : Dupont" type="text" class="form-control" id="nom"
                          formControlName="lastName" [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" />
                        <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                          <div *ngIf="f.lastName.errors.required">Champ obligatoire</div>
                        </div>
                      </div>
                      <div class="col-sm-6 mb-1">
                        <label for="prenom" class="form-label">Prénom</label>
                        <input placeholder="Ex : Marc" type="text" class="form-control" id="prenom"
                          formControlName="firstName" [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" />
                        <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                          <div *ngIf="f.firstName.errors.required">Champ obligatoire</div>
                        </div>
                      </div>
                    </div>
                    <div class="row my-3">
                      <div class="col-sm-6 mb-1">
                        <label for="tel" class="form-label">Téléphone</label>
                        <input placeholder="Ex : 0602030405" type="tel" class="form-control" id="tel"
                          formControlName="phone" [ngClass]="{ 'is-invalid': submitted && f.phone.errors }" />
                        <div *ngIf="submitted && f.phone.errors" class="invalid-feedback">
                          <div *ngIf="f.phone.errors.required">Champ obligatoire</div>
                          <div *ngIf="f.phone.errors.pattern">veuillez saisir un numéro de téléphone
                            valide</div>
                        </div>
                      </div>
                      <div class="col-sm-6 mb-1">
                        <label for="email" class="form-label">Email</label>
                        <input placeholder="Ex : marc.dupont@mail.com" type="email" class="form-control" id="email"
                          formControlName="email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                          <div *ngIf="f.email.errors.required">Champ obligatoire</div>
                          <div *ngIf="f.email.errors.pattern">Veuillez saisir une adresse e-mail
                            valide</div>
                        </div>
                      </div>
                    </div>
                    <div class="my-4">
                      <div class="py-3 form-check" [ngClass]="{ 'is-invalid': submitted && f.terms.errors }">
                        <input class="form-check-input" type="checkbox" value="" id="terms" formControlName="terms">
                        <label class="form-check-label" for="terms">
                          J'accepte que mes données personnelles soient traitées par THE DOOR MAN pour
                          donner suite à ma demande.
                        </label>
                      </div>
                      <div *ngIf="submitted && f.terms.errors" class="invalid-feedback">
                        <div *ngIf="f.terms.errors.required">Champ obligatoire</div>
                      </div>
                    </div>
                    <div class="my-3">
                      <button (click)="next()" class="btn btn-gold px-4 py-2">Envoyer</button>
                    </div>
                    <div class="my-4">
                      <span class="condition text-black-50 span">
                        En envoyant cette demande, j'accepte que mes données personnelles soient utilisées pour me recontacter
                        dans le cadre de la demande indiquée dans ce formulaire.<br>
                        Aucun autre traitement ne sera effectué avec mes informations.
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12 bgStepper h-100 text-white">
                    <div class="row-cols-md-2 row-cols-sm-1">
                      <div class="mt-2 mt-md-5 py-3 py-md-4 px-3 px-md-2">
                        <h4 class="fw-bold">Votre demande d'estimation</h4>
                        <h5 class="my-2">Gratuite et sans engagement !</h5>
                      </div>
                    </div>
                    <div class="row-cols-md-2 row-cols-sm-1 ">
                      <div class="my-2 card p-3 m-3 m-md-0">
                        <h5 class="text-black-50 fw-semibold">VOTRE BIEN</h5>
                        <span class="text-black"><i style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                          {{choosedLocality?.ville}}</span>
                        <span class="text-black"><i style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                          {{typeBienChoosed?.text}}</span>
                        <div *ngIf="searchForm.controls.nb_piece.value">
                          <span class="text-black" *ngFor="let piece of searchForm.controls.nb_piece.value"><i
                              style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                            <span *ngIf="piece == 1">Studio</span>
                            <span *ngIf="piece > 1">{{piece}} piéce(s)</span>
                          </span>
                        </div>
                        <div *ngIf="searchForm.controls.nb_room.value">
                          <span class="text-black" *ngFor="let room of searchForm.controls.nb_room.value"><i
                              style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                            {{room}} chambre(s)
                          </span>
                        </div>
                        <span class="text-black" *ngIf="searchForm.controls.surface.value"><i style="color: #00579C;"
                            class="bi bi-check2 me-1 h4"></i>
                          {{searchForm.controls.surface.value}} m²</span>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="test-l-5" class="content h-100">
              <div class="form-group h-100">
                <div class="form-group row h-100">
                  <div class="col-md-6 col-sm-12 p-5">
                    <app-modal-alert status="success" titile="C’est envoyé !"
                      message="Votre demande a bien été transmis."
                      description='<strong>Notre équipe reviendra vers vous par téléphone </strong> pour donner suite à votre demande d’estimation.'></app-modal-alert>
                  </div>
                  <div class="col-md-6 col-sm-12 bgStepper h-100 text-white">
                    <div class="row-cols-md-2 row-cols-sm-1">
                      <div class="mt-2 mt-md-5 py-3 py-md-4 px-3 px-md-2">
                        <h4 class="fw-bold">Votre demande d'estimation</h4>
                        <h5 class="my-2">Gratuite et sans engagement !</h5>
                      </div>
                    </div>
                    <div class="row-cols-md-2 row-cols-sm-1 ">
                      <div class="my-2 card p-3 m-3 m-md-0">
                        <h5 class="text-black-50 fw-semibold">VOTRE BIEN</h5>
                        <span class="text-black"><i style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                          {{choosedLocality?.ville}}</span>
                        <span class="text-black"><i style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                          {{typeBienChoosed?.text}}</span>
                        <div *ngIf="searchForm.controls.nb_piece.value">
                          <span class="text-black" *ngFor="let piece of searchForm.controls.nb_piece.value"><i
                              style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                            <span *ngIf="piece == 1">Studio</span>
                            <span *ngIf="piece > 1">{{piece}} piéce(s)</span>
                          </span>
                        </div>
                        <div *ngIf="searchForm.controls.nb_room.value">
                          <span class="text-black" *ngFor="let room of searchForm.controls.nb_room.value"><i
                              style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                            {{room}} chambre(s)
                          </span>
                        </div>
                        <span class="text-black" *ngIf="searchForm.controls.surface.value"><i style="color: #00579C;"
                            class="bi bi-check2 me-1 h4"></i>
                          {{searchForm.controls.surface.value}} m²</span>
                        <h5 class="text-black-50 fw-semibold mt-2">Vos coordonnées</h5>
                        <span class="text-black" *ngIf="searchForm.controls.disponibility.value"><i
                            style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                          Préférence de rappel : {{disponibilityTextArray[searchForm.controls.disponibility.value -
                          1]}}</span>
                        <span class="text-black"><i style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                          {{searchForm.controls.firstName.value}} {{searchForm.controls.lastName.value}}</span>
                        <span class="text-black"><i style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                          {{searchForm.controls.phone.value}}</span>
                        <span class="text-black"><i style="color: #00579C;" class="bi bi-check2 me-1 h4"></i>
                          {{searchForm.controls.email.value}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-template>
  <button class="btn btn-secondary mb-2 me-2" id="clickBtn" (click)="openFullscreen(content)">Estimation rdv</button>
</div>
